import { render, staticRenderFns } from "./SpecialPriceAdjNew.vue?vue&type=template&id=ec2e9fc2&"
import script from "./SpecialPriceAdjNew.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports